import AppLoader from 'components/AppLoader';
import React from 'react';
import useAcceptInvite from './useAcceptInvite';

export default function AcceptInvitePage() {
	useAcceptInvite();
	return <AppLoader />;
}
